module.exports = __webpack_public_path__ + "static/media/digitalmarketing.5c477fe7.png";